import { render, staticRenderFns } from "./ItemPB.vue?vue&type=template&id=a1975ef2"
import script from "./ItemPB.vue?vue&type=script&lang=js"
export * from "./ItemPB.vue?vue&type=script&lang=js"
import style0 from "./_layout.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports